// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import Loader from "../common/Loader";
// import toast from "react-hot-toast";
// import { FaTimes } from "react-icons/fa";
// import RichTextEditor from "../common/RichTextEditor";

// const EditSubserviceModal = ({
//   isOpen,
//   onClose,
//   subservice,
//   onSubserviceUpdated,
//   allSubservices,
//   services,
// }) => {
//   const [service, setService] = useState("");
//   const [subserviceName, setSubserviceName] = useState("");
//   const [title, setTitle] = useState("");
//   const [description, setDescription] = useState("");
//   const [existingImages, setExistingImages] = useState([]);
//   const [newImages, setNewImages] = useState([]);
//   const [overview, setOverview] = useState([]);
//   const [authorName, setAuthorName] = useState("");
//   const [authorDescription, setAuthorDescription] = useState("");
//   const [logo, setLogo] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     if (subservice) {
//       setService(subservice?.service?._id || subservice?.service || "");
//       setSubserviceName(subservice?.subserviceName || "");
//       setTitle(subservice?.title || "");
//       setDescription(subservice?.description?.join("\n") || "");
//       setExistingImages(subservice?.images || []);
//       setOverview(
//         subservice?.overview?.length > 0
//           ? subservice.overview.map((item) => ({
//             ...item,
//             description: item.description?.join("\n") || "",
//           }))
//           : [
//             {
//               name: "",
//               title: "",
//               description: "",
//               images: [],
//               points: [{ heading: "", description: "" }],
//             },
//           ]
//       );
//       setAuthorName(subservice?.authorName || "");
//       setAuthorDescription(subservice?.authorDescription || "");
//       setLogo(subservice?.logo || "");
//     }
//   }, [subservice]);

//   // Upload image to Cloudinary
//   const uploadToCloudinary = async (file) => {
//     const formData = new FormData();
//     formData.append("file", file);
//     formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);

//     const res = await axios.post(
//       `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
//       formData
//     );
//     return res.data.secure_url;
//   };

//   const handleImageUpload = async (e) => {
//     const files = e.target.files;
//     if (!files.length) return;
//     setLoading(true);
//     try {
//       const uploadPromises = Array.from(files).map((file) =>
//         uploadToCloudinary(file)
//       );
//       const uploadedUrls = await Promise.all(uploadPromises);
//       setNewImages([...newImages, ...uploadedUrls]);
//       toast.success("Images uploaded successfully");
//     } catch (err) {
//       toast.error("Image upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleLogoUpload = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setLoading(true);
//     try {
//       const uploadedUrl = await uploadToCloudinary(file);
//       setLogo(uploadedUrl);
//       toast.success("Logo uploaded successfully");
//     } catch (err) {
//       toast.error("Logo upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOverviewImageUpload = async (index, e) => {
//     const files = e.target.files;
//     if (!files.length) return;
//     setLoading(true);
//     try {
//       const uploadPromises = Array.from(files).map((file) =>
//         uploadToCloudinary(file)
//       );
//       const uploadedUrls = await Promise.all(uploadPromises);

//       const updatedOverview = [...overview];
//       updatedOverview[index].images = [
//         ...updatedOverview[index].images,
//         ...uploadedUrls,
//       ];
//       setOverview(updatedOverview);
//       toast.success("Overview images uploaded");
//     } catch (err) {
//       toast.error("Overview image upload failed");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOverviewChange = (index, field, value) => {
//     const newOverview = [...overview];
//     newOverview[index][field] = value;
//     setOverview(newOverview);
//   };

//   const handleOverviewPointChange = (oIndex, pIndex, field, value) => {
//     const newOverview = [...overview];
//     newOverview[oIndex].points[pIndex][field] = value;
//     setOverview(newOverview);
//   };

//   const handleAddOverview = () => {
//     setOverview([
//       ...overview,
//       {
//         name: "",
//         title: "",
//         description: "",
//         images: [],
//         points: [{ heading: "", description: "" }],
//       },
//     ]);
//   };

//   const handleRemoveOverview = (index) => {
//     if (overview.length > 1) {
//       const newOverview = overview.filter((_, i) => i !== index);
//       setOverview(newOverview);
//     }
//   };

//   const handleAddPoint = (oIndex) => {
//     const newOverview = [...overview];
//     newOverview[oIndex].points.push({ heading: "", description: "" });
//     setOverview(newOverview);
//   };

//   const handleRemovePoint = (oIndex, pIndex) => {
//     const newOverview = [...overview];
//     if (newOverview[oIndex].points.length > 1) {
//       newOverview[oIndex].points = newOverview[oIndex].points.filter(
//         (_, i) => i !== pIndex
//       );
//       setOverview(newOverview);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const finalImages = [...existingImages, ...newImages];

//       // Prepare overview data
//       const overviewData = overview.map((item) => ({
//         ...item,
//         description: item.description
//           .split("\n")
//           .map((line) => line.trim())
//           .filter((line) => line),
//       }));

//       // Update subservice
//       const response = await axios.put(
//         `${process.env.REACT_APP_API_URL}/subservices/edit-subservice/${subservice._id}`,
//         {
//           service,
//           subserviceName, // ✅ fixed
//           title,
//           description: description
//             .split("\n")
//             .map((line) => line.trim())
//             .filter((line) => line),
//           images: finalImages,
//           overview: overviewData,
//           authorName: authorName.trim() || undefined,
//           authorDescription: authorDescription.trim() || undefined,
//           logo: logo || undefined,
//         }
//       );

//       onSubserviceUpdated(response?.data?.subservice);
//       setError("");
//       toast.success("Subservice updated successfully");
//       onClose();
//       if (allSubservices) allSubservices();
//     } catch (err) {
//       console.error("Error updating subservice:", err);
//       setError("Failed to update subservice");
//       toast.error("Failed to update subservice");
//     } finally {
//       setLoading(false);
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
//       <div className="bg-white p-6 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
//         <div className="flex justify-between items-center text-xl font-semibold mb-4">
//           <h2 className="">Edit Subservice</h2>
//           <button
//             type="button"
//             onClick={onClose}
//             className="hover:text-gray-600"
//           >
//             <FaTimes />
//           </button>
//         </div>
//         {error && <p className="text-red-500 mb-2">{error}</p>}

//         <form onSubmit={handleSubmit} className="space-y-6">
//           {/* Parent Service */}
//           <div>
//             <label className="block mb-2 font-medium">Parent Service *</label>
//             <select
//               value={service}
//               onChange={(e) => setService(e.target.value)}
//               required
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             >
//               <option value="">Select Service</option>
//               {services?.map((srv) => (
//                 <option key={srv._id} value={srv._id}>
//                   {srv.serviceName}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* Subservice Name */}
//           <div>
//             <label className="block mb-2 font-medium">Subservice Name *</label>
//             <input
//               type="text"
//               placeholder="Enter subservice name"
//               value={subserviceName}
//               onChange={(e) => setSubserviceName(e.target.value)}
//               required
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           {/* Title */}
//           <div>
//             <label className="block mb-2 font-medium">Title</label>
//             <input
//               type="text"
//               placeholder="Enter title (optional)"
//               value={title}
//               onChange={(e) => setTitle(e.target.value)}
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           {/* Description */}
//           <div>
//             <label className="block mb-2 font-medium">Description</label>
//             <RichTextEditor
//               value={description}
//               onChange={(value) => setDescription(value)}
//               placeholder="Enter description..."
//             />
//             <small className="text-gray-500">
//               Use formatting tools to structure your description.
//             </small>
//           </div>


//           {/* Images */}
//           <div>
//             <label className="block mb-2 font-medium">Subservice Images *  (500×400 size)</label>

//             {/* Existing Images */}
//             <div className="mb-3">
//               <p className="text-sm font-medium mb-1">Existing Images:</p>
//               <div className="flex flex-wrap gap-2">
//                 {existingImages.map((img, i) => (
//                   <div key={i} className="relative">
//                     <img
//                       src={img}
//                       alt={`existing-${i}`}
//                       className="w-20 h-20 object-cover rounded border"
//                     />
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setExistingImages(
//                           existingImages.filter((_, index) => index !== i)
//                         )
//                       }
//                       className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs"
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             {/* New Images */}
//             <div className="mb-3">
//               <p className="text-sm font-medium mb-1">New Images:  (500×400 size)</p>
//               <div className="flex flex-wrap gap-2">
//                 {newImages.map((img, i) => (
//                   <div key={i} className="relative">
//                     <img
//                       src={img}
//                       alt={`new-${i}`}
//                       className="w-20 h-20 object-cover rounded border"
//                     />
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setNewImages(newImages.filter((_, index) => index !== i))
//                       }
//                       className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs"
//                     >
//                       ×
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>

//             <input
//               type="file"
//               accept="image/*"
//               multiple
//               onChange={handleImageUpload}
//               className="mb-2"
//             />
//           </div>

//           {/* Overview */}
//           <div>
//             <h3 className="font-semibold text-lg mb-3">Overview Sections</h3>
//             {overview.map((item, i) => (
//               <div key={i} className="border border-gray-300 p-4 rounded-lg mb-4 bg-gray-50">
//                 <div className="flex justify-between items-center mb-3">
//                   <h4 className="font-medium text-gray-700">Overview Item {i + 1}</h4>
//                   {overview.length > 1 && (
//                     <button
//                       type="button"
//                       onClick={() => handleRemoveOverview(i)}
//                       className="text-red-500 hover:text-red-700"
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>

//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                   <div>
//                     <label className="block mb-1 text-sm font-medium">Tab Name *</label>
//                     <input
//                       type="text"
//                       placeholder="e.g., Mobile App Development"
//                       value={item.name}
//                       onChange={(e) => handleOverviewChange(i, "name", e.target.value)}
//                       className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       required
//                     />
//                   </div>
//                 </div>

//                 <div className="mt-4">
//                   <label className="block mb-1 text-sm font-medium">Header</label>
//                   <input
//                     type="text"
//                     placeholder="e.g., Building Cross-Platform Apps"
//                     value={item.title}
//                     onChange={(e) => handleOverviewChange(i, "title", e.target.value)}
//                     className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//                   />
//                 </div>

//                 <div className="mt-4">
//                   <label className="block mb-1 text-sm font-medium">Description</label>
//                   <RichTextEditor
//                     value={item.description}
//                     onChange={(value) => handleOverviewChange(i, "description", value)}
//                     placeholder="Enter descriptions..."
//                   />
//                   <small className="text-gray-500">Use formatting tools to structure your description.</small>
//                 </div>


//                 {/* Points Section */}
//                 <div className="mt-4">
//                   <label className="block mb-1 text-sm font-medium">Points</label>
//                   {item.points?.map((point, pIndex) => (
//                     <div key={pIndex} className="grid grid-cols-1 gap-3 mb-2">
//                       <input
//                         type="text"
//                         placeholder="Point Heading"
//                         value={point.heading}
//                         onChange={(e) => handleOverviewPointChange(i, pIndex, "heading", e.target.value)}
//                         className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//                       />
//                       <div className="w-full">
//                         <RichTextEditor
//                           value={point.description}
//                           onChange={(value) => handleOverviewPointChange(i, pIndex, "description", value)}
//                           placeholder="Enter point description..."
//                         />
//                       </div>

//                       {item.points.length > 1 && (
//                         <button
//                           type="button"
//                           onClick={() => handleRemovePoint(i, pIndex)}
//                           className="text-red-500 text-sm"
//                         >
//                           Remove
//                         </button>
//                       )}
//                     </div>
//                   ))}
//                   <button
//                     type="button"
//                     onClick={() => handleAddPoint(i)}
//                     className="bg-green-500 text-white px-3 py-1 rounded text-sm mt-2"
//                   >
//                     + Add Point
//                   </button>
//                 </div>

//                 {/* Images */}
//                 <div className="mt-4">
//                   <label className="block mb-1 text-sm font-medium">Images</label>
//                   <div className="flex flex-wrap gap-2 mb-2">
//                     {item.images?.map((img, j) => (
//                       <div key={j} className="relative">
//                         <img
//                           src={img}
//                           alt="overview"
//                           className="w-16 h-16 object-cover rounded border"
//                         />
//                         <button
//                           type="button"
//                           onClick={() => {
//                             const updatedOverview = [...overview];
//                             updatedOverview[i].images = updatedOverview[i].images.filter((_, index) => index !== j);
//                             setOverview(updatedOverview);
//                           }}
//                           className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-4 h-4 text-xs"
//                         >
//                           ×
//                         </button>
//                       </div>
//                     ))}
//                   </div>
//                   <input
//                     type="file"
//                     accept="image/*"
//                     multiple
//                     onChange={(e) => handleOverviewImageUpload(i, e)}
//                     className="mb-2"
//                   />
//                 </div>
//               </div>
//             ))}
//             <button
//               type="button"
//               onClick={handleAddOverview}
//               className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
//             >
//               + Add Overview Section
//             </button>
//           </div>

//           {/* Author Name */}
//           <div>
//             <label className="block mb-2 font-medium">Author Name</label>
//             <input
//               type="text"
//               placeholder="Enter author name"
//               value={authorName}
//               onChange={(e) => setAuthorName(e.target.value)}
//               className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
//             />
//           </div>

//           {/* Author Description */}
//           <div>
//             <label className="block mb-2 font-medium">Author Description</label>
//             <RichTextEditor
//               value={authorDescription}
//               onChange={setAuthorDescription}
//               placeholder="Enter author description..."
//             />
//           </div>


//           {/* Logo */}
//           <div>
//             <label className="block mb-2 font-medium">Logo  (160×160 size)</label>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleLogoUpload}
//               className="mb-2"
//             />
//             {logo && (
//               <div className="mt-2">
//                 <img
//                   src={logo}
//                   alt="logo"
//                   className="w-20 h-20 object-cover rounded border"
//                 />
//               </div>
//             )}
//           </div>

//           {/* Actions */}
//           <div className="flex justify-end space-x-4 pt-4 border-t">
//             <button
//               type="button"
//               onClick={onClose}
//               className="bg-gray-300 hover:bg-gray-400 px-6 py-2 rounded"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={loading}
//               className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded disabled:opacity-50"
//             >
//               {loading ? <Loader /> : "Update Subservice"}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default EditSubserviceModal;


import React, { useState, useEffect } from "react";
import axios from "axios";
import Loader from "../common/Loader";
import toast from "react-hot-toast";
import { FaTimes } from "react-icons/fa";
import RichTextEditor from "../common/RichTextEditor";

const EditSubserviceModal = ({
  isOpen,
  onClose,
  subservice,
  onSubserviceUpdated,
  allSubservices,
  services,
}) => {
  const [service, setService] = useState("");
  const [subserviceName, setSubserviceName] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [existingImages, setExistingImages] = useState([]);
  const [newImages, setNewImages] = useState([]);
  const [overview, setOverview] = useState([]);
  const [authorName, setAuthorName] = useState("");
  const [authorDescription, setAuthorDescription] = useState("");
  const [logo, setLogo] = useState("");
  const [order, setOrder] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // SEO Fields
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [metaKeywords, setMetaKeywords] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");

  useEffect(() => {
    if (subservice) {
      const data = subservice.data || subservice;
      setService(data?.service?._id || data?.service || "");
      setSubserviceName(data?.subserviceName || "");
      setTitle(data?.title || "");
      setDescription(data?.description?.join("\n") || "");
      setExistingImages(data?.images || []);
      setOrder(data?.order || 0);
      setOverview(
        data?.overview?.length > 0
          ? data.overview.map((item) => ({
            ...item,
            description: item.description?.join("\n") || "",
          }))
          : [
            {
              name: "",
              title: "",
              description: "",
              images: [],
              points: [{ heading: "", description: "" }],
            },
          ]
      );
      setAuthorName(data?.authorName || "");
      setAuthorDescription(data?.authorDescription || "");
      setLogo(data?.logo || "");
      
      // SEO Fields
      setMetaTitle(data?.metaTitle || "");
      setMetaDescription(data?.metaDescription || "");
      setMetaKeywords(data?.metaKeywords || "");
      setCanonicalUrl(data?.canonicalUrl || "");
    }
  }, [subservice]);

  // Auto-generate meta title when subservice name changes
  useEffect(() => {
    if (subserviceName && !metaTitle) {
      setMetaTitle(`${subserviceName} | BBSR Services`);
    }
  }, [subserviceName]);

  // Upload image to Cloudinary
  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("upload_preset", process.env.REACT_APP_UPLOAD_PRESET);

    const res = await axios.post(
      `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME}/image/upload`,
      formData
    );
    return res.data.secure_url;
  };

  const handleImageUpload = async (e) => {
    const files = e.target.files;
    if (!files.length) return;
    setLoading(true);
    try {
      const uploadPromises = Array.from(files).map((file) =>
        uploadToCloudinary(file)
      );
      const uploadedUrls = await Promise.all(uploadPromises);
      setNewImages([...newImages, ...uploadedUrls]);
      toast.success("Images uploaded successfully");
    } catch (err) {
      toast.error("Image upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLoading(true);
    try {
      const uploadedUrl = await uploadToCloudinary(file);
      setLogo(uploadedUrl);
      toast.success("Logo uploaded successfully");
    } catch (err) {
      toast.error("Logo upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleOverviewImageUpload = async (index, e) => {
    const files = e.target.files;
    if (!files.length) return;
    setLoading(true);
    try {
      const uploadPromises = Array.from(files).map((file) =>
        uploadToCloudinary(file)
      );
      const uploadedUrls = await Promise.all(uploadPromises);

      const updatedOverview = [...overview];
      updatedOverview[index].images = [
        ...updatedOverview[index].images,
        ...uploadedUrls,
      ];
      setOverview(updatedOverview);
      toast.success("Overview images uploaded");
    } catch (err) {
      toast.error("Overview image upload failed");
    } finally {
      setLoading(false);
    }
  };

  const handleOverviewChange = (index, field, value) => {
    const newOverview = [...overview];
    newOverview[index][field] = value;
    setOverview(newOverview);
  };

  const handleOverviewPointChange = (oIndex, pIndex, field, value) => {
    const newOverview = [...overview];
    newOverview[oIndex].points[pIndex][field] = value;
    setOverview(newOverview);
  };

  const handleAddOverview = () => {
    setOverview([
      ...overview,
      {
        name: "",
        title: "",
        description: "",
        images: [],
        points: [{ heading: "", description: "" }],
      },
    ]);
  };

  const handleRemoveOverview = (index) => {
    if (overview.length > 1) {
      const newOverview = overview.filter((_, i) => i !== index);
      setOverview(newOverview);
    }
  };

  const handleAddPoint = (oIndex) => {
    const newOverview = [...overview];
    newOverview[oIndex].points.push({ heading: "", description: "" });
    setOverview(newOverview);
  };

  const handleRemovePoint = (oIndex, pIndex) => {
    const newOverview = [...overview];
    if (newOverview[oIndex].points.length > 1) {
      newOverview[oIndex].points = newOverview[oIndex].points.filter(
        (_, i) => i !== pIndex
      );
      setOverview(newOverview);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const finalImages = [...existingImages, ...newImages];

      // Prepare overview data
      const overviewData = overview.map((item) => ({
        ...item,
        description: item.description
          ? item.description.split("\n").map((line) => line.trim()).filter((line) => line)
          : [],
      }));

      // Update subservice
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/subservices/edit-subservice/${subservice._id || subservice.data?._id}`,
        {
          service,
          subserviceName,
          title,
          description: description
            ? description.split("\n").map((line) => line.trim()).filter((line) => line)
            : [],
          images: finalImages,
          overview: overviewData,
          authorName: authorName.trim() || undefined,
          authorDescription: authorDescription.trim() || undefined,
          logo: logo || undefined,
          order: order || 0,
          // SEO Fields
          metaTitle: metaTitle.trim() || `${subserviceName} | BBSR Services`,
          metaDescription: metaDescription.trim() || description?.split("\n").filter(d => d.trim())[0]?.substring(0, 160) || '',
          metaKeywords: metaKeywords.trim() || `${subserviceName}, BBSR Services, business solutions`,
          canonicalUrl: canonicalUrl.trim() || `https://www.bbsrservices.co.in/sub-service/${subserviceName.toLowerCase().replace(/\s+/g, '-')}`
        }
      );

      onSubserviceUpdated(response?.data?.data);
      setError("");
      // toast.success("Subservice updated successfully");
      onClose();
      if (allSubservices) allSubservices();
    } catch (err) {
      console.error("Error updating subservice:", err);
      setError("Failed to update subservice");
      toast.error("Failed to update subservice");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center text-xl font-semibold mb-4">
          <h2 className="">Edit Subservice</h2>
          <button
            type="button"
            onClick={onClose}
            className="hover:text-gray-600"
          >
            <FaTimes />
          </button>
        </div>
        {error && <p className="text-red-500 mb-2">{error}</p>}

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Parent Service */}
          <div>
            <label className="block mb-2 font-medium">Parent Service *</label>
            <select
              value={service}
              onChange={(e) => setService(e.target.value)}
              required
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Service</option>
              {services?.map((srv) => (
                <option key={srv._id} value={srv._id}>
                  {srv.serviceName}
                </option>
              ))}
            </select>
          </div>

          {/* Subservice Name */}
          <div>
            <label className="block mb-2 font-medium">Subservice Name *</label>
            <input
              type="text"
              placeholder="Enter subservice name"
              value={subserviceName}
              onChange={(e) => setSubserviceName(e.target.value)}
              required
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Title */}
          <div>
            <label className="block mb-2 font-medium">Title</label>
            <input
              type="text"
              placeholder="Enter title (optional)"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Order */}
          <div>
            <label className="block mb-2 font-medium">Display Order</label>
            <input
              type="number"
              placeholder="Enter order number (0, 1, 2, ...)"
              value={order}
              onChange={(e) => setOrder(parseInt(e.target.value) || 0)}
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <p className="text-xs text-gray-500 mt-1">Lower numbers appear first in the navbar</p>
          </div>

          {/* Description */}
          <div>
            <label className="block mb-2 font-medium">Description</label>
            <RichTextEditor
              value={description}
              onChange={(value) => setDescription(value)}
              placeholder="Enter description..."
            />
            <small className="text-gray-500">
              Use formatting tools to structure your description.
            </small>
          </div>

          {/* Images */}
          <div>
            <label className="block mb-2 font-medium">Subservice Images * (500×400 size)</label>

            {/* Existing Images */}
            <div className="mb-3">
              <p className="text-sm font-medium mb-1">Existing Images:</p>
              <div className="flex flex-wrap gap-2">
                {existingImages.map((img, i) => (
                  <div key={i} className="relative">
                    <img
                      src={img}
                      alt={`existing-${i}`}
                      className="w-20 h-20 object-cover rounded border"
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setExistingImages(
                          existingImages.filter((_, index) => index !== i)
                        )
                      }
                      className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>

            {/* New Images */}
            <div className="mb-3">
              <p className="text-sm font-medium mb-1">New Images: (500×400 size)</p>
              <div className="flex flex-wrap gap-2">
                {newImages.map((img, i) => (
                  <div key={i} className="relative">
                    <img
                      src={img}
                      alt={`new-${i}`}
                      className="w-20 h-20 object-cover rounded border"
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setNewImages(newImages.filter((_, index) => index !== i))
                      }
                      className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 text-xs"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <input
              type="file"
              accept="image/*"
              multiple
              onChange={handleImageUpload}
              className="mb-2"
            />
          </div>

          {/* Overview */}
          <div>
            <h3 className="font-semibold text-lg mb-3">Overview Sections</h3>
            {overview.map((item, i) => (
              <div key={i} className="border border-gray-300 p-4 rounded-lg mb-4 bg-gray-50">
                <div className="flex justify-between items-center mb-3">
                  <h4 className="font-medium text-gray-700">Overview Item {i + 1}</h4>
                  {overview.length > 1 && (
                    <button
                      type="button"
                      onClick={() => handleRemoveOverview(i)}
                      className="text-red-500 hover:text-red-700"
                    >
                      Remove
                    </button>
                  )}
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block mb-1 text-sm font-medium">Tab Name *</label>
                    <input
                      type="text"
                      placeholder="e.g., Mobile App Development"
                      value={item.name}
                      onChange={(e) => handleOverviewChange(i, "name", e.target.value)}
                      className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>
                </div>

                <div className="mt-4">
                  <label className="block mb-1 text-sm font-medium">Header</label>
                  <input
                    type="text"
                    placeholder="e.g., Building Cross-Platform Apps"
                    value={item.title}
                    onChange={(e) => handleOverviewChange(i, "title", e.target.value)}
                    className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div className="mt-4">
                  <label className="block mb-1 text-sm font-medium">Description</label>
                  <RichTextEditor
                    value={item.description}
                    onChange={(value) => handleOverviewChange(i, "description", value)}
                    placeholder="Enter descriptions..."
                  />
                  <small className="text-gray-500">Use formatting tools to structure your description.</small>
                </div>

                {/* Points Section */}
                <div className="mt-4">
                  <label className="block mb-1 text-sm font-medium">Points</label>
                  {item.points?.map((point, pIndex) => (
                    <div key={pIndex} className="grid grid-cols-1 gap-3 mb-2">
                      <input
                        type="text"
                        placeholder="Point Heading"
                        value={point.heading}
                        onChange={(e) => handleOverviewPointChange(i, pIndex, "heading", e.target.value)}
                        className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <div className="w-full">
                        <RichTextEditor
                          value={point.description}
                          onChange={(value) => handleOverviewPointChange(i, pIndex, "description", value)}
                          placeholder="Enter point description..."
                        />
                      </div>

                      {item.points.length > 1 && (
                        <button
                          type="button"
                          onClick={() => handleRemovePoint(i, pIndex)}
                          className="text-red-500 text-sm"
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => handleAddPoint(i)}
                    className="bg-green-500 text-white px-3 py-1 rounded text-sm mt-2"
                  >
                    + Add Point
                  </button>
                </div>

                {/* Images */}
                <div className="mt-4">
                  <label className="block mb-1 text-sm font-medium">Images</label>
                  <div className="flex flex-wrap gap-2 mb-2">
                    {item.images?.map((img, j) => (
                      <div key={j} className="relative">
                        <img
                          src={img}
                          alt="overview"
                          className="w-16 h-16 object-cover rounded border"
                        />
                        <button
                          type="button"
                          onClick={() => {
                            const updatedOverview = [...overview];
                            updatedOverview[i].images = updatedOverview[i].images.filter((_, index) => index !== j);
                            setOverview(updatedOverview);
                          }}
                          className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-4 h-4 text-xs"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => handleOverviewImageUpload(i, e)}
                    className="mb-2"
                  />
                </div>
              </div>
            ))}
            <button
              type="button"
              onClick={handleAddOverview}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              + Add Overview Section
            </button>
          </div>

          {/* Author Name */}
          <div>
            <label className="block mb-2 font-medium">Author Name</label>
            <input
              type="text"
              placeholder="Enter author name"
              value={authorName}
              onChange={(e) => setAuthorName(e.target.value)}
              className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Author Description */}
          <div>
            <label className="block mb-2 font-medium">Author Description</label>
            <RichTextEditor
              value={authorDescription}
              onChange={setAuthorDescription}
              placeholder="Enter author description..."
            />
          </div>

          {/* Logo */}
          <div>
            <label className="block mb-2 font-medium">Logo (160×160 size)</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleLogoUpload}
              className="mb-2"
            />
            {logo && (
              <div className="mt-2">
                <img
                  src={logo}
                  alt="logo"
                  className="w-20 h-20 object-cover rounded border"
                />
              </div>
            )}
          </div>

          {/* SEO Section */}
          <div className="border-t pt-4 mt-4">
            <h3 className="text-lg font-semibold text-blue-600 mb-3">SEO Settings</h3>
            <div className="space-y-3">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta Title</label>
                <input
                  type="text"
                  placeholder="Meta Title (SEO)"
                  value={metaTitle}
                  onChange={(e) => setMetaTitle(e.target.value)}
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500">{metaTitle?.length || 0}/60 characters</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta Description</label>
                <textarea
                  placeholder="Meta Description (SEO)"
                  value={metaDescription}
                  onChange={(e) => setMetaDescription(e.target.value)}
                  rows="3"
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500">{metaDescription?.length || 0}/160 characters</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Meta Keywords</label>
                <input
                  type="text"
                  placeholder="Meta Keywords (SEO)"
                  value={metaKeywords}
                  onChange={(e) => setMetaKeywords(e.target.value)}
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500">Separate keywords with commas</p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Canonical URL</label>
                <input
                  type="url"
                  placeholder="Canonical URL"
                  value={canonicalUrl}
                  onChange={(e) => setCanonicalUrl(e.target.value)}
                  className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Actions */}
          <div className="flex justify-end space-x-4 pt-4 border-t">
            <button
              type="button"
              onClick={onClose}
              className="bg-gray-300 hover:bg-gray-400 px-6 py-2 rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded disabled:opacity-50"
            >
              {loading ? <Loader /> : "Update Subservice"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditSubserviceModal;